import React from 'react';
import { FormattedMessage } from 'react-intl';
import type { PackageType } from '@shipstation/client-common/types/seller-data';
import { ButtonSizes } from 'ui-components/components/button/button-sizes';
import { DropdownMenu } from 'ui-components/components/dropdown-menu';
import { DropdownMenuItem } from 'ui-components/components/dropdown-menu-item';
import { DropdownMenuToggler } from 'ui-components/components/dropdown-menu-toggler';
import { THEME_CONSTANTS } from 'ui-components/services/button-theme-service';

import { messages } from './custom-package-list-messages';

type CustomPackageListProps = {
  applyCustomPackage: (pkg: PackageType) => void;
  customPackages?: PackageType[];
};

export const CustomPackageList = ({ applyCustomPackage, customPackages = [] }: CustomPackageListProps) => (
  <DropdownMenu>
    <DropdownMenuToggler buttonSize={ButtonSizes.small} theme={THEME_CONSTANTS.link}>
      <FormattedMessage {...messages.applyCustomPackageSize} />
    </DropdownMenuToggler>
    {customPackages.map((pkg) => (
      <DropdownMenuItem key={pkg.packageTypeId} onClick={() => applyCustomPackage(pkg)}>
        {pkg.name}
      </DropdownMenuItem>
    ))}
  </DropdownMenu>
);
